<template>
  <div>
    <div>
      <div
        style="
          background-size: cover;
          color: #fff;
          position: fixed;
          width: 100%;
          top: 0px;
        "
        :style="{ backgroundImage: `url(${backgroundBanner})` }"
        class="d-none d-sm-flex"
      >
        <div style="width: 100%" class="mt-5 m-0">
          <h3 class="text-center text-white m-0">Payment</h3>
          <br />
          <br />
        </div>
      </div>
      <div
        style="
          background-size: cover;
          color: #fff;
          position: fixed;
          width: 100%;
          top: 0px;
        "
        :style="{ backgroundImage: `url(${backgroundBanner})` }"
        class="d-flex d-sm-none"
      >
        <div style="width: 100%" class="mt-3">
          <CCol sm="12">
            <span class="mt-5 mb-5"></span>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </CCol>
        </div>
      </div>
      <CCard style="height: 100vh" class="custom-card">
        <CRow>
          <CCol sm="12" class="justify-content-center m-0">
            <CContainer>
              <CCol sm="12" lg="12">
                <CRow>
                  <h5
                    class="text-left mt-4 d-flex text-black bold"
                    style="font-size: 24px"
                  >
                    Payment
                    <br />
                  </h5>

                  <CCol sm="12" lg="12" class="justify-content-center">
                    <CRow>
                      <CCol sm="12" lg="12" class="p-2">
                        <CRow>
                          <CCol sm="12" lg="12">
                            <CRow class="d-flex">
                              <CCol sm="12" class="mt-2">
                                <strong>Security Password</strong> :
                                <CInput
                                  type="text"
                                  v-model="CheckPassword"
                                  class="mt-2"
                                />
                              </CCol>
                              <CCol sm="12" class="mt-2">
                                <strong>Date</strong> :
                                <CInput type="date" v-model="DatePayment" />
                              </CCol>
                              <CCol sm="12" class="mt-2">
                                <strong>Time</strong> :
                                <CInput type="time" v-model="TimePayment" />
                              </CCol>
                              <CCol sm="12" class="mt-2">
                                <strong>Total Amount</strong> :
                                <CInput type="text" v-model="TotalAmount" />
                              </CCol>
                              <CCol sm="12" class="mt-2">
                                <strong>User</strong> :
                                <v-select
                                  v-model="SelectedUser"
                                  :options="users"
                                  label="Name"
                                  placeholder="-- Please Select Your Name--"
                                  required
                                  @input="GetTeacherName(SelectedUser.Id)"
                                ></v-select>
                              </CCol>
                            </CRow>
                          </CCol>

                          <CCol sm="12" lg="12" class="mt-2 text-center">
                            <br />
                            <CButton
                              color="success"
                              @click="GetPasswordCheck(CheckPassword)"
                              class="mb-2 custom-btn"
                              block
                              >Submit Payment</CButton
                            >
                          </CCol>
                          <CCol sm="12">
                            <div v-if="ErrorMessage==true" class="ml-4 mr-4">
                    <CAlert show color="danger">
                      <strong class="text-danger mr-2">X ERROR ! Wrong Password </strong>
                    </CAlert>
                  </div>
                  <div v-if="SuccessMessage==true" class="ml-4 mr-4">
                    <CAlert show color="success">You have successfully save the payment</CAlert>
                  </div>
                          </CCol>
                          <br />
                        </CRow>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CContainer>
          </CCol>
        </CRow>
      </CCard>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/bgLogin.png";
import backgroundUrlTemplate from "../assets/img/bg.png";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

import backgroundBanner from "../assets/img/bgApps.jpg";
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      users: [],
      teachers: [],
      Busy: false,
      status: false,

      CheckPassword: "",
      SelectedUser: "",
      DatePayment: "",
      TimePayment: "",
      TotalAmount: 0,
      ErrorMessage: false,
      SuccessMessage: false,
    };
  },
  async mounted() {
    await this.GetAllFindTutor();
  },
  methods: {
    async GetAllFindTutor() {
      this.$API
        .get(this.$GetUsersPayment, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.users = response.data;
          }
        });
    },
    async GetPasswordCheck(CheckPassword) {
      this.$API
        .get(this.$GetCheckPassword + "?currentPass=" + CheckPassword, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {

          
              this.SubmitPayment();
            
          }
          else if(response.status == 500)
          {
 this.ErrorMessage = true;
          }
          else
          {
            this.ErrorMessage = true;
          }
        });
    },

    SubmitPayment() {
      const formData = new FormData();

      formData.append("date", this.DatePayment);
      formData.append("time", this.TimePayment);

       formData.append("amount", this.TotalAmount);
      formData.append("userId", this.SelectedUser.Id);

      return this.$API
        .post(this.$EwalletDirectPayment, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.SuccessMessage = true;
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.ErrorMessage = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>
